import styled, { createGlobalStyle, keyframes } from "styled-components";
import bgImage from "assets/images/bg.png";
import lapki from "assets/icons/lapki.svg";
import HagridRegular from "@assets/fonts/hagrid.ttf";
import { theme } from "@theme";

const animalsStyles = `
  body::after {
    content: "";
    position: absolute;
    inset: 0 0 0 0;
    background: url(${lapki});
    user-select: none;
    z-index: -1;
  }
`;

export const GlobalStyle = createGlobalStyle`
  /* @font-face {
    font-family: 'Hagrid-Regular';
    src: url(${HagridRegular}) format("truetype");
    font-weight: normal;
    font-style: normal;
  } */

  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Inter', sans-serif;
    font-weight: 400;
  }

  body {
    height: 100%;
    background: url(${bgImage}) no-repeat center center fixed;
    background-size: cover;
  }
  
  html {
    height: 100%;
  }

  html,
  body {
    width: 100vw;
    overflow-x: hidden;
  }

  ::-webkit-scrollbar {
    width: 12px;
  }

  ::-webkit-scrollbar-track {
    background-color: #f8ebe3; /* Light beige/pink */
  }

  ::-webkit-scrollbar-thumb {
    background-color: #dcbbaa; /* A soft brownish-pink */
    border-radius: 6px;
    border: 2px solid #f8ebe3; /* Matches the track color, creates a "thumb" effect */
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #c2a18c; /* Slightly darker on hover */
  }

  /* For Firefox */
  * {
    scrollbar-width: thin;
    scrollbar-color: #dcbbaa #f8ebe3;
  }

  .ant-input-affix-wrapper {
    padding: 0 11px;
  }

  .candle-slider .ant-tooltip-inner {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 24px !important;
    background: #FFFBF8 !important;
    border-radius: 12px !important;
    border: 1px solid #C6A691 !important;
    min-width: 24px !important;
    min-height: 24px !important;
    color: #391D0A !important;
  }
  .ant-tooltip-arrow {
    display: none !important;
  }

  .light-button {
    border-radius: 6px;
    background: rgba(189, 152, 127, 0.20);
    backdrop-filter: blur(5px);
    z-index: 999;
  }

  .crop-image {
    z-index: 999999 !important;
  }

  #birthday {
    @media screen and (max-width: ${theme.breakpoints.sm}) {
      width: 100%;
    }
  }
  
  .date-selectors-add-story-label {
    .ant-form-item-label {
      padding-bottom: 4px !important;
    }
  }

  .responsive-form-item div {
    .select-wrapper {
      width: 120px;
      
      @media screen and (max-width: ${theme.breakpoints.sm}) {
        width: 100%;
        flex-direction: column !important;
      }
    }
  }

  .ant-form {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .tributes-list > .ant-segmented > .ant-segmented-group > .ant-segmented-item-selected {
    color: rgba(255, 255, 255, 1) !important;
  }
  .tributes-list > .ant-segmented > .ant-segmented-group > .ant-segmented-item {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    color: rgba(89, 78, 71, 1);
  }

  .tributes-list > .ant-segmented > .ant-segmented-group > .ant-segmented-item > .ant-segmented-item-label {
    overflow: visible;
  }

  .tributes-list > .ant-segmented {
    height: 49px;
    padding: 4px;
    border: 1px solid rgba(228, 215, 205, 1);
    background: rgba(249, 242, 236, 1);
  }

  .candle-message {
    height: calc(100% - 50px);
    overflow-x: hidden;
    overflow-y: auto;
    max-width: 200px;
    max-height: 80px;
    word-break: break-word;
    scrollbar-width: none;
  }
  .candle-message::-webkit-scrollbar {
    display: none;
  }

  .add-people-form label{
    font-size: 12px !important;
  }

  .myStoriesListDropdown {
    ul {
      background-color: #F9F2EC !important;

      li {
        padding: 0 !important;
      }
    }
  }

  :has(.people-page) .languageContainer {
    bottom: 90px !important;
    z-index: 999;
  }

  .zero-candle-repost {
    h2 {
      color: #391D0A;
      text-align: center;
      margin-bottom: 16px;
    }
    div {
      width: auto;
      background: transparent;
    }
  }

  ${window.location.hostname.includes("animals") && animalsStyles}

  #root {
    min-height: 100%;
    display: flex;
    justify-content: center;
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;

    @media screen and (max-width: ${theme.breakpoints.lg}) {
      padding: 0;
    }
  }
`;

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Loader = styled.div<{ loading?: boolean }>`
  display: ${({ loading }) => (loading ? "flex" : "none")};
  position: ${({ loading }) => loading && "fixed"};
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  justify-content: center;
  align-items: center;
  background: #f9f2ec;
  z-index: 9999;
`;
export const Loading = styled.div`
  width: 64px;
  height: 64px;
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-top: 2px solid #c6a691;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

export const LanguageContainer = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 1000;
`;

export const LanguageButton = styled.button`
  background-color: #fff;
  color: #b29b84;
  border: none;
  padding: 12px 18px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;
